import MuiSlider from "@mui/material/Slider";
import styles from "./styles.module.scss";


const StyledSlider: React.FC<{ identifier?: string, val: number, setVal: (val: number) => void }> = ({ identifier, val, setVal }) => (
    <div className={styles.styled_slider}>
        <MuiSlider
            aria-label={identifier}
            value={val}
            min={0}
            max={100}
            step={1}
            aria-labelledby="Zoom"
            onChange={(e, newVolume) => setVal(Number(newVolume))}
            classes={{
                thumb: styles.thumb,
                active: styles.active,
            }}
            style={{
                color: 'var(--primary-color)'
            }}
            size='small'
            name={identifier}
        />
    </div>
)

export default StyledSlider;
